import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface GestionarServiciosDiaData {
  codigoBodega: string;
  fechaPicking: string;
  totalServicios: number;
  elegiblesCierre: number;
  elegiblesApertura: number;
}

export interface GestionarServiciosDiaResultado {
  accion: 'CERRAR' | 'ABRIR';
}

@Component({
  selector: 'app-modal-gestionar-servicios-dia',
  templateUrl: './modal-gestionar-servicios-dia.component.html',
  styleUrls: ['./modal-gestionar-servicios-dia.component.scss']
})
export class ModalGestionarServiciosDiaComponent {
  constructor(
    public dialogRef: MatDialogRef<ModalGestionarServiciosDiaComponent, GestionarServiciosDiaResultado | undefined>,
    @Inject(MAT_DIALOG_DATA) public data: GestionarServiciosDiaData
  ) { }

  cerrarTodos(): void {
    this.dialogRef.close({ accion: 'CERRAR' });
  }

  abrirTodos(): void {
    this.dialogRef.close({ accion: 'ABRIR' });
  }

  cancelar(): void {
    this.dialogRef.close(undefined);
  }
}
